goog.provide("shadow.js.shim.module$$mui$material$Tab");
goog.provide("module$shadow_js_shim_module$$mui$material$Tab");
shadow.js.shim.module$$mui$material$Tab = shadow.js.nativeProvides["@mui/material/Tab"] = shadow$bridge("@mui/material/Tab");
module$shadow_js_shim_module$$mui$material$Tab.default = shadow.js.shim.module$$mui$material$Tab;
